import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { useNavigate } from 'react-router-dom';
import { compose } from 'redux';
import {
  ResultContainer,
  CardsGrid,
  FiltersContainer,
  SelectsContainer,
  Filter,
} from './style';
import routes from '../../../routes';
import { NoResult, CardCourses, CustomSelect, CTA } from '../../../ui/atoms';
import { SEARCH_EVENTS_LIST_GET } from '../../redux/actions/search';
import Pagination from '../../../ui/atoms/Pagination';
import { flattenCategories } from '../../../utils/categories';
import SortBy from '../../../ui/atoms/SortBy';
import {
  DURATION_OPTIONS,
  formatFilterOpt,
  getFilterLabel,
} from '../../../utils/labels';
import { withMediaQueries } from '../../hoc/withMediaQueries';
import { MODAL_OPEN } from '../../redux/actions';
import { StickyFiltersWrapper } from '../../../ui/atoms/CTA/style';
import ModalFilters, {
  ModalFiltersId,
} from '../../../ui/atoms/Modals/ModalFilters';

const EventResults = ({
  mediaIsPhone,
  active,
  search_word,
  categories,
  getEvents,
  list,
  filters,
  pager,
  modalOpen,
}) => {
  const navigate = useNavigate();
  const [selectedFilters, setSelectedFilters] = useState({});

  const handleGetCourses = (page) => {
    getEvents({
      title: search_word,
      filters: {
        ...selectedFilters,
        categoryType: 'single_categories',
        is_module: false,
        page,
      },
    });
  };

  useEffect(() => {
    if (Object.keys(selectedFilters)?.length > 0) {
      handleGetCourses();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFilters]);

  const redirectCourseDetails = (id) => {
    navigate(`${routes.courseDetails.path}/${id}/panoramica`);
  };

  const handleOnChange = ({ key, value }) => {
    const newFilters = { ...selectedFilters };
    newFilters[key] = value?.value;
    setSelectedFilters(newFilters);
  };

  const loadMore = (page) => handleGetCourses(page);
  const setItemsPerPage = (v) =>
    handleOnChange({ key: 'items_per_page', value: v });

  return (
    <>
      {mediaIsPhone ? (
        <StickyFiltersWrapper>
          <CTA
            btnText="Filtri"
            type="secondary"
            fullsize
            onClick={() =>
              modalOpen(ModalFiltersId, {
                filters: {
                  categories: flattenCategories(categories),
                  ...filters,
                  duration: DURATION_OPTIONS,
                },
                activeFilters: selectedFilters,
              })
            }
          />
        </StickyFiltersWrapper>
      ) : (
        <FiltersContainer>
          <SelectsContainer>
            <Filter>
              <CustomSelect
                placeholder="Area tematica"
                options={flattenCategories(categories, 0, true)}
                onChange={(v) => {
                  setSelectedFilters({
                    ...selectedFilters,
                    categories: v?.value,
                  });
                }}
                isClearable
              />
            </Filter>
            {(Object.keys(filters) || []).map((key, i) => (
              <Filter key={`filter-${i}`}>
                <CustomSelect
                  placeholder={getFilterLabel(key)}
                  options={filters[key].map((opt) => formatFilterOpt(opt))}
                  onChange={(value) => handleOnChange({ key, value })}
                  isClearable
                />
              </Filter>
            ))}
            <Filter>
              <CustomSelect
                placeholder="Durata"
                options={DURATION_OPTIONS}
                isClearable
                onChange={(v) =>
                  setSelectedFilters({
                    ...selectedFilters,
                    duration: v?.value,
                  })
                }
              />
            </Filter>
            <SortBy
              onChange={(v) => {
                setSelectedFilters({ ...selectedFilters, sort_by: v?.value });
              }}
            />
          </SelectsContainer>
        </FiltersContainer>
      )}
      {/* ALL COURSES */}
      {list.length > 0 && (
        <ResultContainer>
          <CardsGrid>
            {(list || []).map((item) => (
              <CardCourses
                key={`course-${item.id}`}
                item={item}
                onClick={() => redirectCourseDetails(item.id)}
              />
            ))}
          </CardsGrid>
        </ResultContainer>
      )}
      <Pagination
        pager={pager}
        callBack={loadMore}
        setItemsPerPage={setItemsPerPage}
      />
      {list?.length === 0 && <NoResult />}
      {mediaIsPhone && active && (
        <ModalFilters
          onClick={(newFilters) => setSelectedFilters(newFilters)}
        />
      )}
    </>
  );
};

EventResults.propTypes = {
  mediaIsPhone: PropTypes.bool,
  active: PropTypes.bool,
  // HOC (connect, state)
  search_word: PropTypes.string,
  list: PropTypes.array.isRequired,
  filters: PropTypes.object,
  pager: PropTypes.object,
  categories: PropTypes.array,
  //HOC (connect, dispatch)
  getEvents: PropTypes.func.isRequired,
  modalOpen: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => {
      const {
        search_word,
        events: { list, filters, pager },
      } = state.search;
      const { categories } = state.courselist;
      return {
        search_word,
        list,
        filters,
        pager,
        categories,
      };
    },
    (dispatch) => ({
      getEvents: ({ title, filters }) =>
        dispatch({ type: SEARCH_EVENTS_LIST_GET._REQUEST, filters, title }),
      modalOpen: (id, payload) => dispatch({ type: MODAL_OPEN, id, payload }),
    })
  ),
  withMediaQueries
)(EventResults);
